import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

import styled from 'styled-components';
import Modal from '../Modal';

import checkForm from './images/check-form.svg';

import './style/prevBriefing.scss';
import api from '../../services/api';
import MoldalFooter from './MoldalFooter';
import ScrollTop from '../Utils/ScrollTop';

const BriefingStyled = styled.div`
	.content-briefing {
		margin-top: 30px !important;
	}
`;

export default class Briefing extends Component {
	state = {
		showModal: false,
	};

	openModal = () => {
		const { showModal, closedModal } = this.state;
		if (!showModal && !closedModal) {
			this.setState({
				showModal: true,
			});
		}
	};

	closeModal = () => {
		this.setState({
			showModal: false,
			closedModal: true,
		});
	};

	resetBriefing = () => {
		const { location, history } = this.props;
		const briefingId = (location.briefingId)
			? location.briefingId : history.location.state.briefingId;
		api.post(`/briefings/${briefingId}/reset`)
			.then((response) => {
				const briefing = response.data;
				if (briefing.success) {
					return history.push({ pathname: './briefing/clonar/selecionar' }, { briefingId, pre_sale_id: location.state.pre_sale_id });
				}

				return false;
			});
	};

	beginBriefing = () => {
		window.scrollTo(0, 80);
		const { location, history } = this.props;
		const briefingId = (location.briefingId)
			? location.briefingId : history.location.state.briefingId;
		api.get(`/briefings/${briefingId}`)
			.then((response) => {
				const briefing = response.data.data;
				const step = briefing.relationships.step;

				localStorage.setItem('step-data', JSON.stringify(response.data.data));

				return history.push({ pathname: `./briefing/${briefing.id}/step/${step.id}`, state: { data: response.data } });
			});
	};

	renderContentStepPreBriefing = () => {
		const { location } = this.props;

		if (location.state.cloned) {
			this.openModal();
		}

		return (
			<BriefingStyled>
				<ScrollTop />
				<div className="content-briefing">
					<h3>VAMOS COMEÇAR? MAS ANTES...</h3>
					<ul className="topics-begin list-style-disc">
						<li>
							<span>
								Tenha o arquivo do logo da loja em PNG, alta definição e fundo transparente.
								Sem o arquivo com essas especificações sua campanha nas redes sociais não
								poderá ser realizada.
							</span>
						</li>

						<li>
							<span>
								Campanhas nas Redes Sociais só poderão ser efetuadas após a validação
								de um “Termo de aceite”. Em breve você receberá um e-mail com as
								instruções. Para saber mais: &nbsp;
								<a
									href="http://midias.webmotors.com.br/termodeaceite"
									target="_blank"
									rel="noopener noreferrer"
									className="text-dark underlined"
								>
									Clique aqui!
								</a>
							</span>
						</li>

						<li>
							<span>
								Todas as informações relevantes devem ser inseridas neste briefing.
								Lembre-se que os demais canais de atendimento, como e-mail, telefone
								e whatsapp, são apenas para solucionar dúvidas.
							</span>
						</li>

						<li>
							<span>
								Estamos à disposição desde já. Não hesite em nos contatar! Afinal,
								estamos comprometidos com o seu sucesso!
								<span role="img" aria-label="feliz">😉</span>
							</span>
						</li>
					</ul>

					<div className="content-buttons">
						{location.state.cloned ? (
							<button
								type="button"
								className="btn btn-light"
								onClick={this.resetBriefing}
							>
								Voltar
							</button>
						)
							: (
								<a
									href="./briefings"
									className="btn btn-light"
								>
									Voltar
								</a>
							)
						}
						<button
							type="button"
							className="btn btn-success btn-no-border"
							onClick={this.beginBriefing}
						>Próximo
						</button>
					</div>
				</div>
			</BriefingStyled>
		);
	};

	render() {
		const { location } = this.props;
		if (typeof location.state === 'undefined' || location.state.briefingId <= 0) {
			return <Redirect to="./briefings" />;
		}

		const {
			showModal,
		} = this.state;

		const sourceId = (location.state.pre_sale_id !== undefined)
			? location.state.pre_sale_id : location.state.briefing.pre_sale_id;

		return (
			<section className="component-briefing">
				<div className="container-begin-briefing">
					<div className="container-fluid">
						<div className="row">
							<div className="col-12">
								<h2>Bem-vindo ao Briefing</h2>
							</div>
						</div>

						<div className="box-content">
							<div className="row">
								<div className="col-12">
									<div className="box-title">
										<img src={checkForm} alt="ícone formulário" className="icon-form" />
										<h3>{sourceId}</h3>
									</div>
								</div>
							</div>

							<div className="row">
								<div className="col-12">
									{this.renderContentStepPreBriefing()}
								</div>
							</div>

							<div className="row">
								<div className="col-12">
									<MoldalFooter />
								</div>
							</div>
						</div>
					</div>
				</div>

				{(showModal)
					? (
						<Modal
							sourceId={sourceId}
							closeAction={this.closeModal}
							buttonAction={this.closeModal}
						/>
					)
					: ''}
			</section>
		);
	}
}
